import { useUnsubscribe } from './Unsubscribe.hooks';
import { useTranslation } from 'react-i18next';
import { Button } from '@app/components/Button/Button';
import VerticalLogo from '@app/assets/vertical-logo.svg?react';

export const Unsubscribe = () => {
  const { t } = useTranslation();
  const {
    isSuccess,
    error,
    performUnsubscribe,
    isLoading,
  } = useUnsubscribe();

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-4 sm:py-6 gap-4 sm:gap-6">
      <div className="flex flex-col items-center gap-6 mb-8">
        <VerticalLogo className="w-32 h-auto" />
      </div>
      <div className="bg-white text-center space-y-4 rounded w-full max-w-[845px] py-4 sm:py-6 px-4 sm:px-20">
        <div className="flex flex-col items-center gap-4">
          {!(isSuccess || error) && (
            <>
              <h2 className="font-bold text-2xl sm:text-3xl leading-none">
                Are you sure you want to unsubscribe?
              </h2>
              <div className="flex flex-col sm:flex-row gap-2 mt-4">
                <Button
                    onClick={() => performUnsubscribe() }
                    className="w-full sm:w-auto"
                    disabled={isLoading}
                >
                  Unsubscribe
                </Button>
                <Button
                    kind="secondary"
                    onClick={() => window.history.back()}
                    className="w-full sm:w-auto"
                    disabled={isLoading}
                >
                  Cancel
                </Button>
              </div>
            </>
          )}

          {isSuccess && (
            <>
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-brand-lightBlue3">
                <svg
                  className="w-8 h-8 text-brand-baseBlue"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h2 className="font-bold text-2xl sm:text-3xl leading-none text-brand-baseBlue">
                {t('unsubscribe.success', 'Successfully Unsubscribed')}
              </h2>
              <p className="text-base-coolGray text-sm sm:text-base">
                {t('unsubscribe.successMessage', 'You have been successfully unsubscribed from our communications.')}
              </p>

            </>
          )}

          {error && (
            <>
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100">
                <svg
                  className="w-8 h-8 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <h2 className="font-bold text-2xl sm:text-3xl leading-none text-red-600">
                {t('unsubscribe.error', 'Unsubscribe Failed')}
              </h2>
              <p className="text-base-coolGray text-sm sm:text-base">
                {error}
              </p>
              <div className="flex flex-col sm:flex-row gap-2 mt-4">
                  <Button
                      onClick={() => performUnsubscribe() }
                      className="w-full sm:w-auto"
                      disabled={isLoading}
                  >
                      {t('unsubscribe.tryAgain', 'Try Again')}
                  </Button>
                  <Button
                      kind="secondary"
                      onClick={() => window.history.back()}
                      className="w-full sm:w-auto"
                      disabled={isLoading}
                  >
                      Cancel
                  </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};